import React from "react";
import "./Education.css";
import { IoBook } from "react-icons/io5";
import education from "./Education.json";

const Education = () => {
  return (
    <section className="timeline">
      <div className="title-wrapper">
        <div className="icon-box">
          <IoBook />
        </div>
        <h3 className="h3">Education</h3>
      </div>

      <ol className="timeline-list">
        {education.map((edu, index) => (
          <li className="timeline-item" key={index}>
            {/* Degree */}
            <h4 className="h4 timeline-item-title">{edu.degree}</h4>

            {/* College */}
            <p className="timeline-text">{edu.college}</p>

            {/* University / Board */}
            <p className="timeline-text">{edu.university}</p>

            {/* Year */}
            <span>{edu.year}</span>

            {/* CGPA / Percentage (optional) */}
            {edu.percentage && (
              <p className="timeline-text">{edu.percentage}</p>
            )}
          </li>
        ))}
      </ol>
    </section>
  );
};

export default Education;
